var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.showFooter ? '' : 'hidden'},[_c('p',[_vm._v(_vm._s(_vm.fullDate(_vm.currentDay)))]),_c('div'),_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }